import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllFAQs = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_FAQS_REQUEST" });

      const { data } = await axios.get(`${BASE_URL}/faq/all`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FAQS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FAQS_FAILURE", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FAQS_FAILURE",
        payload: error?.response?.data?.message || error?.message,
      });
      return {
        success: false,
        message: error?.response?.data?.message || error?.message,
      };
    }
  };
};

export const addFAQ = (faqData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_FAQ_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/faq/add`,
        faqData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_FAQ_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "ADD_FAQ_FAILURE", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_FAQ_FAILURE",
        payload: error?.response?.data?.message || error?.message,
      });

      return {
        success: false,
        message: error?.response?.data?.message || error?.message,
      };
    }
  };
};

export const updateFAQ = (faqData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_FAQ_REQUEST" });

      const { data } = await axios.put(
        `${BASE_URL}/faq/update`,
        faqData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_FAQ_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "UPDATE_FAQ_FAILURE", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_FAQ_FAILURE",
        payload: error?.response?.data?.message || error?.message,
      });

      return {
        success: false,
        message: error?.response?.data?.message || error?.message,
      };
    }
  };
};

export const getFAQById = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_FAQ_REQUEST" });

      const { data } = await axios.get(`${BASE_URL}/faq/view/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_FAQ_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_FAQ_FAILURE", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_FAQ_FAILURE",
        payload: error?.response?.data?.message || error?.message,
      });

      return {
        success: false,
        message: error?.response?.data?.message || error?.message,
      };
    }
  };
};